$('.video').on('click', '.video__play, .video__close', function() {
  const $this = $(this);
  const $parent = $this.closest('.video');
  const $video = $parent.find('video');
  if ($video[0].paused) {
    $video[0].play();
  }else{
    $video[0].pause();
  }
  $parent.toggleClass('playing');
})



// WEBPACK FOOTER //
// ../assets/js/video.js